import axios from 'axios';
import api from './endpoints';

export default {
  list() {
    return axios.get(api.PAGES)
      .then((data) => data.data);
  },
  page(args) {
    return axios.get(api.resolveEndpoint(api.PAGE, [args.slug]))
      .then((data) => data.data);
  },
  create(args) {
    return axios.post(api.SECURE_PAGES, args)
      .then((result) => result.data);
  },
  edit(args) {
    return axios.put(api.resolveEndpoint(api.SECURE_PAGE, [args.slug]), args)
      .then((result) => result.data);
  },
  detail(args) {
    return axios.get(api.resolveEndpoint(api.SECURE_PAGE, [args.slug]), args)
      .then((result) => result.data);
  }
};
